// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '@ajm... Remove this comment to see the full error message
import toaster from '@ajmey/toaster';
const defaultOpts = {
    theme: 'bumblebee',
    animation: 'slide-up',
    dismiss: 4000,
    type: 'info',
};
const validTypes = ['info', 'success', 'failure', 'warning'];
const toasters = {
    info: (msg, opts) => toaster.info(msg, opts),
    success: (msg, opts) => toaster.success(msg, opts),
    failure: (msg, opts) => toaster.failure(msg, { ...opts, dismiss: false }),
    warning: (msg, opts) => toaster.warning(msg, opts),
};
const toast = (msg, opts = defaultOpts) => {
    if (!validTypes.includes(opts.type)) {
        /* eslint-disable-next-line no-param-reassign */
        opts.type = defaultOpts.type;
    }
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const r = toasters[opts.type](msg, { ...defaultOpts, ...opts });
    return {
        toast: r,
        toaster,
    };
};
toast.defaultOpts = defaultOpts;
export default toast;
